import { initializeApp } from "firebase/app";
import {
  getMessaging,
  isSupported,
  getToken,
  onMessage,
  Messaging
} from "firebase/messaging";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAUj10iJ9lCeTKgCpxO1EUn6HzrhvxzWkA",
  authDomain: "teratasks.firebaseapp.com",
  projectId: "teratasks",
  storageBucket: "teratasks.firebasestorage.app",
  messagingSenderId: "7981267432",
  appId: "1:7981267432:web:b962bb06dbe4de887e8c5d",
  measurementId: "G-VG5SZS3YR9"
};

const app = initializeApp(firebaseConfig);

// ==============================
// 🔍 DETEKSI WEBVIEW / CAPACITOR
// ==============================
const isWebView = (): boolean => {
  // Capacitor native — skip Firebase JS SDK, gunakan @capacitor/push-notifications
  if ((window as any).Capacitor?.isNativePlatform?.()) return true;
  if (typeof navigator === "undefined") return false;
  return /wv|Android.*Version\/\d+\.\d+/i.test(navigator.userAgent);
};

// ==============================
// 🔐 SINGLETON MESSAGING
// ==============================
let messagingInstance: Messaging | null = null;

const getMessagingSafe = async (): Promise<Messaging | null> => {
  try {
    if (isWebView()) {
      console.warn("Running in WebView → skip FCM Web");
      return null;
    }

    const supported = await isSupported();

    if (!supported) {
      console.warn("FCM not supported in this browser. Note: Di iOS Safari, butuh iOS 16.4+ dan web harus di-'Add to Home Screen' (PWA) agar didukung.");
      return null;
    }

    if (!messagingInstance) {
      messagingInstance = getMessaging(app);
    }

    return messagingInstance;
  } catch (error) {
    console.error("Error initializing messaging:", error);
    return null;
  }
};

// ==============================
// 🔔 REQUEST PERMISSION + TOKEN
// ==============================
export const requestNotificationPermission = async () => {
  try {
    const messaging = await getMessagingSafe();
    if (!messaging) return null;

    if (!("Notification" in window)) {
      console.warn("Notification API not supported. Jika di iOS, user harus Add to Home Screen.");
      return null;
    }

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.warn("Notification permission denied");
      return null;
    }

    let currentToken: string | null = null;

    // ✅ Hanya pakai Service Worker di browser asli
    if ("serviceWorker" in navigator && !isWebView()) {
      try {
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );

        currentToken = await getToken(messaging, {
          vapidKey:
            "BCS6oDicB1lZUSOjsGC20GKwyj5KosPXLnpkKe-LqVH7v7B2r-jwiE9bfhiNJgen8W6yLPLwbO0OFZ997ZzC4E4",
          serviceWorkerRegistration: registration
        });
      } catch (swError) {
        console.warn("Service Worker failed, fallback without SW", swError);

        currentToken = await getToken(messaging, {
          vapidKey:
            "BCS6oDicB1lZUSOjsGC20GKwyj5KosPXLnpkKe-LqVH7v7B2r-jwiE9bfhiNJgen8W6yLPLwbO0OFZ997ZzC4E4"
        });
      }
    } else {
      // fallback (jarang dipakai, tapi aman)
      currentToken = await getToken(messaging, {
        vapidKey:
          "BCS6oDicB1lZUSOjsGC20GKwyj5KosPXLnpkKe-LqVH7v7B2r-jwiE9bfhiNJgen8W6yLPLwbO0OFZ997ZzC4E4"
      });
    }

    console.log("FCM Token:", currentToken);
    return currentToken;
  } catch (error) {
    console.error("Error getting notification token:", error);
    return null;
  }
};

// ==============================
// 📩 LISTENER FOREGROUND MESSAGE
// ==============================
export const onMessageListener = (callback: (payload: any) => void) => {
  let unsubscribe: (() => void) | null = null;

  getMessagingSafe().then((messaging) => {
    if (!messaging) return;

    unsubscribe = onMessage(messaging, (payload) => {
      callback(payload);
    });
  });

  return () => {
    if (unsubscribe) unsubscribe();
  };
};